import { alpha } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const styles = makeStyles((theme: Theme) => ({
  formControl: {
    margin: theme.spacing(2),
    minWidth: 152,
    backgroundColor: alpha(theme.palette.common.white, 0.12),
    borderRadius: 5,
  },
  selectBorder: {
    // Border styling handled by inline styles
  },
}));

export const outlinedInputStyles = makeStyles((_theme: Theme) => ({
  root: {
    '& $notchedOutline': {
      borderColor: 'transparent',
    },
    '&:hover $notchedOutline': {
      borderColor: 'transparent',
    },
    '&$focused $notchedOutline': {
      borderColor: 'transparent',
    },
  },
  focused: {},
  notchedOutline: {},
}));
